import { useMemo } from "react";
import { createCnoLine, updateCnoLine } from "../../../services/api";
import {
    appendLine,
    buildLineSave,
    emptyLine,
    lineClientId,
    linesReadyToSave,
    normalizeLine,
    patchLine,
    replaceLine,
    replaceStatus,
    saveKeyForLine,
} from "../model/cnoRules";

// Lignes CNO du patient sélectionné : ajout, saisie et enregistrement groupé.
export default function useCnoLines(cno) {
    const { selectedPatientId, selectedPatient, saveStatuses, setPatients, setSaveStatuses, setSaveError, markStatus } = cno;

    const cnoLinesReadyToSave = useMemo(
        () => linesReadyToSave(selectedPatient, saveStatuses),
        [saveStatuses, selectedPatient]
    );

    const addCno = () => {
        if (!selectedPatientId) return;
        const line = emptyLine();
        markStatus(saveKeyForLine(line.clientId), "dirty");
        setPatients(current => appendLine(current, selectedPatientId, line));
    };

    const updateCno = (clientId, patch) => {
        markStatus(saveKeyForLine(clientId), "dirty");
        setPatients(current => patchLine(current, selectedPatientId, clientId, patch));
    };

    const saveCno = (line, patch = {}) => {
        if (typeof selectedPatientId !== "number" || !line) return Promise.resolve(false);
        const patientId = selectedPatientId;
        const clientId = lineClientId(line);
        const statusKey = saveKeyForLine(clientId);
        const save = buildLineSave(line, patch);
        if (!save) {
            markStatus(statusKey, "dirty");
            return Promise.resolve(false);
        }
        markStatus(statusKey, "saving");
        const request = typeof line.id === "number"
            ? updateCnoLine(patientId, line.id, save.payload)
            : createCnoLine(patientId, save.createPayload);
        return request.then(response => {
            const savedLine = { ...normalizeLine(response.data), clientId };
            setPatients(current => replaceLine(current, patientId, clientId, savedLine));
            setSaveStatuses(current => replaceStatus(current, statusKey, statusKey, "saved"));
        }).catch(() => {
            markStatus(statusKey, "error");
            setSaveError("La modification CNO n'a pas pu être sauvegardée en base.");
            return false;
        });
    };

    const saveReadyCnos = async () => {
        if (cnoLinesReadyToSave.length === 0) return;
        setSaveError("");
        await Promise.all(cnoLinesReadyToSave.map(line => saveCno(line)));
    };

    return { cnoLinesReadyToSave, addCno, updateCno, saveReadyCnos };
}
